export type SortOption =
  | "best"
  | "cheapest"
  | "quickest"
  | "earliest"
  | "latest";

export interface PriceRange {
  min: number;
  max: number;
}

export interface TimeRange {
  start: string; // 24h format "HH:mm"
  end: string;
}

export interface FilterState {
  sort: SortOption;
  airlines: string[];
  maxStops: number | null;
  priceRange: PriceRange | null;
  departureTime: TimeRange | null;
  arrivalTime: TimeRange | null;
  cabinClass: "M" | "W" | "C" | "F" | null; // M = Economy, W = Premium Economy, C = Business, F = First
}

export const defaultFilterState: FilterState = {
  sort: "best",
  airlines: [],
  maxStops: null,
  priceRange: null,
  departureTime: null,
  arrivalTime: null,
  cabinClass: null,
};

export const cabinClassOptions = [
  { value: "M", label: "Economy" },
  { value: "W", label: "Premium Economy" },
  { value: "C", label: "Business" },
  { value: "F", label: "First" },
];

export const sortOptions = [
  { value: "best", label: "Best", icon: "star" },
  { value: "cheapest", label: "Cheapest", icon: "money-bill-wave" },
  { value: "quickest", label: "Quickest", icon: "stopwatch" },
  { value: "earliest", label: "Earliest Departure", icon: "sun" },
  { value: "latest", label: "Latest Departure", icon: "moon" },
];
